export default "__VITE_ASSET__B8odSj7H__"